import { STORAGE_LNG } from "config/const/global"
import { getCookie } from "./cookies"
import { EN, ZH, ZH_CN } from "config/const/locale";

export const STATUS = [
    'pending',
    'processing',
    'failed',
    'success',
    'unpaid',
    'paid'
]

/**
 * return i18n status text
 * @param {string} status pending, processing, failed, successful
 */
export default function getI18nStatusText(status) {
    const lang = getCookie(STORAGE_LNG)

    switch (lang) {
        case ZH:
            switch (status) {
                case 'pending':
                    return <span style={{ color: 'thistle' }}>等待中</span>
                case 'processing':
                    return <span style={{ color: 'cornflowerblue' }}>處理中</span>
                case 'failed':
                    return <span style={{ color: 'darkviolet' }}>申請失敗</span>
                case 'success':
                    return <span style={{ color: 'green' }}>申請成功</span>
                case 'unpaid':
                    return <span style={{ color: 'red' }}>未付款</span>
                case 'paid':
                    return <span style={{ color: 'blue' }}>已付款</span>

                default:
                    return <span style={{ color: 'silver' }}>未知</span>
            }
        case ZH_CN:
            switch (status) {
                case 'pending':
                    return <span style={{ color: 'thistle' }}>等待中</span>
                case 'processing':
                    return <span style={{ color: 'cornflowerblue' }}>处理中</span>
                case 'failed':
                    return <span style={{ color: 'darkviolet' }}>申請失敗</span>
                case 'success':
                    return <span style={{ color: 'green' }}>申请失败</span>
                case 'unpaid':
                    return <span style={{ color: 'red' }}>未付款</span>
                case 'paid':
                    return <span style={{ color: 'blue' }}>已付款</span>

                default:
                    return <span style={{ color: 'silver' }}>未知</span>
            }
        case EN:
            switch (status) {
                case 'pending':
                    return <span style={{ color: 'thistle' }}>pending</span>
                case 'processing':
                    return <span style={{ color: 'cornflowerblue' }}>processing</span>
                case 'failed':
                    return <span style={{ color: 'darkviolet' }}>failed</span>
                case 'success':
                    return <span style={{ color: 'green' }}>success</span>
                case 'unpaid':
                    return <span style={{ color: 'red' }}>unpaid</span>
                case 'paid':
                    return <span style={{ color: 'blue' }}>paid</span>

                default:
                    return <span style={{ color: 'silver' }}>unknonw</span>
            }

        default:
            switch (status) {
                case 'pending':
                    return <span style={{ color: 'thistle' }}>等待中</span>
                case 'processing':
                    return <span style={{ color: 'cornflowerblue' }}>處理中</span>
                case 'failed':
                    return <span style={{ color: 'darkviolet' }}>申請失敗</span>
                case 'success':
                    return <span style={{ color: 'green' }}>申請成功</span>
                case 'unpaid':
                    return <span style={{ color: 'red' }}>未付款</span>
                case 'paid':
                    return <span style={{ color: 'blue' }}>已付款</span>

                default:
                    return <span style={{ color: 'silver' }}>未知</span>
            }
    }

}
